import React, { useState } from "react";
import AddOrg from "./components/AddOrg";

function AddOrganization() {
  const initialFormValue = {
    orgName: "",
    payinProviderName: "",
    payoutProviderName: "",
    orgDomainURL: "",
    orgLogo: "",
    orgAddress: "",
    orgPhoneNumber: "",
    orgGSTIN: "",
    orgCompanyName: "",
    ip01: "",
    ip02: "",
  };

  const [formData, setFormData] = useState(initialFormValue);

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setFormData({ ...formData, [name]: value });
  };

  return (
    <>
      <h1 style={{ marginBottom: "20px" }}>Add Organization</h1>
      <AddOrg
        formData={formData}
        setFormData={setFormData}
        handleInputChange={handleInputChange}
        initialFormValue={initialFormValue}
      />
    </>
  );
}

export default AddOrganization;
